import React, { useState } from 'react'

function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null)

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index)
  }

  const faqs = [
    {
      question: 'Wie viel kann ich mit spotx verdienen?',
      answer: 'Du verdienst 0,067€ pro vollständig angesehener Kampagne. Pro Tag sind das bis zu 0,335€ (5 Kampagnen), pro Woche 2,345€ und pro Monat bis zu 10,05€ möglich.'
    },
    {
      question: 'Wie funktioniert die Auszahlung?',
      answer: 'Belohnungen werden sofort nach vollständiger Ansicht einer Kampagne gutgeschrieben. Die Auszahlung erfolgt über das integrierte Belohnungssystem. Alle Transaktionen sind transparent einsehbar.'
    },
    {
      question: 'Wann sind die Kampagnen verfügbar?',
      answer: 'Es gibt 5 tägliche Zeitfenster: 09:00, 12:00, 15:00, 18:00 und 21:00 Uhr. Jeder Slot ist 2 Stunden aktiv (1 Stunde vor bis 1 Stunde nach der Slot-Zeit). Du erhältst Benachrichtigungen zu den Slot-Zeiten.'
    },
    {
      question: 'Wie lange muss ich eine Kampagne ansehen?',
      answer: 'Jede Kampagne hat einen 5-Sekunden-Timer. Der X-Button erscheint nach 2 Sekunden an zufälliger Position. Du kannst die Kampagne nach mindestens 5 Sekunden manuell schließen. Nur vollständig angesehene Kampagnen werden belohnt.'
    },
    {
      question: 'Ist spotx kostenlos?',
      answer: 'Ja, die spotx App ist komplett kostenlos. Es gibt keine versteckten Kosten oder Abonnements. Du verdienst Geld durch das Ansehen von Kampagnen.'
    },
    {
      question: 'Auf welchen Geräten funktioniert spotx?',
      answer: 'spotx ist für iOS und Android optimiert und verfügbar. Die App bietet eine intuitive Oberfläche mit Dark Mode und schneller Navigation auf beiden Plattformen.'
    }
  ]

  return (
    <section id="faq" className="faq section">
      <div className="container">
        <h2 className="section-title">Häufig gestellte Fragen</h2>
        <p className="section-subtitle">
          Alles was du über spotx wissen musst
        </p>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${activeIndex === index ? 'active' : ''}`}
            >
              <div
                className="faq-question"
                onClick={() => toggleFAQ(index)}
              >
                <span>{faq.question}</span>
                <span className="faq-icon">▼</span>
              </div>
              <div className="faq-answer">
                <div className="faq-answer-content">{faq.answer}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FAQ
